import useStore, { updateScreenWidth } from '../Store/Store';

import AppleIcon from '@mui/icons-material/Apple';
import FacebookIcon from '@mui/icons-material/Facebook';
import GoogleIcon from '@mui/icons-material/Google';
import MicrosoftIcon from '@mui/icons-material/Microsoft';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Link,
  TextField,
  Typography,
} from '@mui/material';
import React from 'react';
import Logo from '../images/logo.png';
import SideImage from '../images/loginImage.svg';
import {
  getTokenData,
  resendOtpApi,
  signupApi,
  signupByInvite,
  updateUserInfo,
  updateUserType,
  verifyOtpApi,
} from '../utils/api';
import { useMutation } from 'react-query';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { auth, provider, signInWithPopup } from '../utils/firebase';
import { isEmpty, isEqual, replace } from 'lodash';
import DoneIcon from '@mui/icons-material/Done';
import Otp from './SignupOnboardingSteps/Otp';
import { toast } from 'react-toastify';
import UserType from './SignupOnboardingSteps/UserType';
import UserForm from './SignupOnboardingSteps/UserForm';
import InviteCareTeam from './SignupOnboardingSteps/InviteCareTeam';
import InviteCareRecipients from './SignupOnboardingSteps/InviteCareRecipients';
import validator from '../input-validation.service';
import { careUserType } from '../constants';
import DeviceIntegration from './SignupOnboardingSteps/DeviceIntegration';
import { CameraAlt } from '@mui/icons-material';
import PhoneInput from 'react-phone-number-input';
import { useQuery } from 'react-query';
import moment from 'moment';

const LogIn = () => {
  const history = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const width = useStore((state) => state.screenWidth);
  const user = useStore((state) => state.user);
  const uploadRef = React.useRef();

  const [step, setStep] = React.useState(0);
  const [state, setState] = React.useState({
    firstName: '',
    lastName: '',
    birthday: '',
    email: '',
    password: '',
    phoneNo: '',
    errorMessage: '',
    showPassword: false,
    image: '',
    imageToDisplay: null,
    emailDisabled: false,
    phoneDisabled: false,
  });

  const [passwordChecker, setPasswordChecker] = React.useState({
    length: false,
    number: false,
    special: false,
  });

  const {
    data: tokenData,
    isLoading,
    refetch,
  } = useQuery(['getUserInfo', query], () => getTokenData({ token: query.get('token') }), {
    retry: false,
    cacheTime: 0,
  });

  const signUpHandler = useMutation(signupByInvite, {
    onSuccess: async ({ data }) => {
      history('/login');
    },
    onError: (error) => {
      console.log('error =====> ', error);
      if (error?.response?.status === 400) {
        return setState((prev) => {
          return { ...prev, errorMessage: error?.response?.data?.data?.join(',') || 'Something went wrong!' };
        });
      } else {
        return setState((prev) => {
          return { ...prev, errorMessage: error?.response?.data?.message || 'Something went wrong!' };
        });
      }
    },
  });

  const updateDimensions = () => {
    updateScreenWidth(window.innerWidth);
  };
  React.useEffect(() => {
    window.addEventListener('resize', updateDimensions);
    return () => window.removeEventListener('resize', updateDimensions);
  }, []);

  React.useEffect(() => {
    if (!isEmpty(user)) {
      history('/main');
    }
  }, [user]);

  const handleBackStep = () => {
    setStep(0);
  };

  const handleOpenImageUpload = () => {
    uploadRef.current.click();
  };

  const handleSetImage = async (e) => {
    try {
      const image = e.target.files[0];

      const response = await axios.get(
        `${process.env.REACT_APP_EXPRESS_URL}/api/users/${sessionStorage.getItem('userId')}/getSignedImageURL`,
        {
          headers: {
            'Content-Type': 'application/json',
            authorization: sessionStorage.getItem('token'),
          },
        },
      );

      if (response.status !== 200) {
        throw new Error('Incorrect email or password');
      }

      const postURL = response?.data?.data?.postURL;

      await axios.put(postURL, image, {
        headers: {
          'Content-Type': 'image/jpeg',
        },
      });

      setState((prev) => {
        return { ...prev, image: postURL.split('?')[0], imageToDisplay: URL.createObjectURL(image) };
      });
    } catch (error) {
      console.error('Error uploading image:', error);
    }
  };

  const handleSetPassword = (event) => {
    const { value } = event.target;

    if (value.length > 8) {
      setPasswordChecker((prev) => {
        return { ...prev, length: true };
      });
    } else {
      setPasswordChecker((prev) => {
        return { ...prev, length: false };
      });
    }
    if (/[0-9]/.test(value)) {
      setPasswordChecker((prev) => {
        return { ...prev, number: true };
      });
    } else {
      setPasswordChecker((prev) => {
        return { ...prev, number: false };
      });
    }
    if (/[^a-zA-Z0-9]/.test(value)) {
      setPasswordChecker((prev) => {
        return { ...prev, special: true };
      });
    } else {
      setPasswordChecker((prev) => {
        return { ...prev, special: false };
      });
    }

    setState((prev) => {
      return { ...prev, password: event.target.value };
    });
  };

  const handleNextStep = () => {
    const { firstName, lastName, birthday, phoneNo, image, password, email } = state;
    if (isEmpty(firstName)) {
      return setState((prev) => {
        return { ...prev, errorMessage: 'First Name cannot be empty' };
      });
    }
    if (isEmpty(lastName)) {
      return setState((prev) => {
        return { ...prev, errorMessage: 'Last Name cannot be empty' };
      });
    }
    if (isEmpty(birthday)) {
      return setState((prev) => {
        return { ...prev, errorMessage: 'Birth date cannot be empty' };
      });
    }
    if (isEmpty(password)) {
      return setState((prev) => {
        return { ...prev, errorMessage: 'Birth date cannot be empty' };
      });
    }
    if (isEmpty(email)) {
      return setState((prev) => {
        return { ...prev, errorMessage: 'Email cannot be empty' };
      });
    }
    if (isEmpty(phoneNo) || !validator.validatePhoneNumber(phoneNo)) {
      return setState((prev) => {
        return { ...prev, errorMessage: 'Phone is not valid' };
      });
    }

    setState((prev) => {
      return { ...prev, errorMessage: '' };
    });

    const body = {
      firstName,
      lastName,
      birthdate: birthday,
      password,
      phoneNo,
      image,
      email,
      token: query.get('token'),
    };

    signUpHandler.mutate({ body });
  };

  React.useEffect(() => {
    if (!isEmpty(tokenData?.data)) {
      let phoneDisabled = false;
      let emailDisabled = false;
      let email = '';
      let phone = '';

      if (!isEqual(tokenData?.data?.phoneNumber, 'null')) {
        phone = tokenData?.data?.phoneNumber || '';
        phoneDisabled = true;
      } else {
        email = tokenData?.data?.email;
        emailDisabled = true;
      }
      setState((prev) => {
        return { ...prev, email, phoneNo: phone, phoneDisabled, emailDisabled };
      });
    }
  }, [tokenData]);

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100vw',
        height: '100vh',
        backgroundColor: 'white',
      }}
    >
      {step === 0 && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: width > 1050 ? '50%' : '100%',
            padding: '1rem',
          }}
        >
          <Box
            component="img"
            sx={{ width: '55px', height: '37.56px', marginBottom: '2rem' }}
            alt="Mask group"
            src={Logo}
          />
          <div style={{ paddingInline: '4rem', paddingBlock: '10rem' }}>
            <Typography variant="h4" gutterBottom mb={6}>
              {tokenData?.data?.fullName || 'CAN User'} invited you to be a{' '}
              {replace(tokenData?.data?.role, '_', ' ') || 'caregiver'}
            </Typography>

            <Button
              variant="contained"
              fullWidth
              sx={{
                borderRadius: '50px',
                marginBottom: '1rem',
                background: '#01796b',
              }}
              onClick={() => setStep(1)}
            >
              Create Account
            </Button>
          </div>
        </Box>
      )}
      {step === 1 && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: width > 1050 ? '50%' : '100%',
            padding: '1rem',
          }}
        >
          <Box
            component="img"
            sx={{ width: '55px', height: '37.56px', marginBottom: '2rem' }}
            alt="Mask group"
            src={Logo}
          />
          <div style={{ paddingInline: '4rem', paddingBlock: '3rem' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              <Typography variant="h4" sx={{ fontWeight: 'medium', color: 'rgba(29, 29, 31, 1)' }}>
                Create your account
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                {isEmpty(state.imageToDisplay) ? (
                  <IconButton
                    sx={{ width: 70, height: 70, backgroundColor: 'rgba(245, 245, 247, 1)', borderRadius: '100px' }}
                  >
                    <CameraAlt />
                  </IconButton>
                ) : (
                  <img src={state.imageToDisplay} alt="image" style={{ width: 70, height: 70, borderRadius: '50%' }} />
                )}
                <input type="file" style={{ display: 'none' }} onChange={handleSetImage} ref={uploadRef} />
                <Button
                  variant="outlined"
                  sx={{ borderRadius: '100px', padding: '8px 16px', color: 'black', borderColor: 'black' }}
                  onClick={handleOpenImageUpload}
                >
                  Upload photo
                </Button>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                <TextField
                  label="First name*"
                  placeholder="Linda"
                  variant="outlined"
                  fullWidth
                  InputProps={{ style: { borderRadius: '100px' } }}
                  onChange={(e) =>
                    setState((prev) => {
                      return {
                        ...prev,
                        firstName: e.target.value,
                      };
                    })
                  }
                  value={state.firstName}
                />
                <TextField
                  label="Last name*"
                  placeholder="Wilson"
                  variant="outlined"
                  fullWidth
                  InputProps={{ style: { borderRadius: '100px' } }}
                  onChange={(e) =>
                    setState((prev) => {
                      return {
                        ...prev,
                        lastName: e.target.value,
                      };
                    })
                  }
                  value={state.lastName}
                />
                <TextField
                  type="date"
                  placeholder="MM/DD/YYYY"
                  variant="outlined"
                  fullWidth
                  InputProps={{
                    style: { borderRadius: '100px' },
                  }}
                  onChange={(e) =>
                    setState((prev) => {
                      return {
                        ...prev,
                        birthday: e.target.value,
                      };
                    })
                  }
                  value={state.birthday}
                />
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <PhoneInput
                    placeholder="Enter phone number"
                    defaultCountry="US"
                    addInternationalOption={true}
                    limitMaxLength={true}
                    style={{
                      border: '1px solid #C2C8D6',
                      boxSizing: 'border-box',
                      height: '57px',
                      paddingLeft: '20px',
                      marginTop: '8px',
                      borderRadius: '100px',
                      width: '100%',
                    }}
                    value={state.phoneNo}
                    numberInputProps={{
                      className: 'input-child input-child-2',
                    }}
                    onChange={(value) =>
                      setState((prev) => {
                        return {
                          ...prev,
                          phoneNo: value,
                        };
                      })
                    }
                    disabled={state.phoneDisabled}
                  />
                </Box>
                <TextField
                  label="Email"
                  variant="outlined"
                  fullWidth
                  InputProps={{ style: { borderRadius: '100px' } }}
                  value={state.email}
                  disabled={state.emailDisabled}
                />
                <TextField
                  label="Password"
                  variant="outlined"
                  fullWidth
                  type={state.showPassword ? 'text' : 'password'}
                  sx={{ borderRadius: '50px' }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          edge="end"
                          onClick={() =>
                            setState((prev) => {
                              return { ...prev, showPassword: !prev.showPassword };
                            })
                          }
                        >
                          {!state.showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                        </IconButton>
                      </InputAdornment>
                    ),
                    style: { borderRadius: '50px' },
                  }}
                  onChange={handleSetPassword}
                />
                <div style={{ display: 'flex', fontSize: '13px', marginBottom: '20px' }}>
                  <div style={{ display: 'flex', color: passwordChecker.length ? '#01796b' : 'grey' }}>
                    <DoneIcon style={{ fontSize: '17px', marginRight: '5px' }} /> Min 8 characters
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      marginInline: '20px',
                      color: passwordChecker.number ? '#01796b' : 'grey',
                    }}
                  >
                    <DoneIcon style={{ fontSize: '17px', marginRight: '5px' }} /> 1 number
                  </div>
                  <div style={{ display: 'flex', color: passwordChecker.special ? '#01796b' : 'grey' }}>
                    <DoneIcon style={{ fontSize: '17px', marginRight: '5px' }} /> 1 special character
                  </div>
                </div>
              </Box>
            </Box>
            <Box sx={{ display: 'flex', gap: 6, marginTop: '40px' }}>
              <Button
                variant="outlined"
                sx={{ flex: 1, borderRadius: '100px', color: 'black', borderColor: 'black' }}
                onClick={handleBackStep}
              >
                Back
              </Button>
              <Button
                variant="contained"
                color="primary"
                sx={{ flex: 1, borderRadius: '100px', backgroundColor: '#01796b' }}
                onClick={handleNextStep}
                disabled={signUpHandler.isLoading}
              >
                {signUpHandler.isLoading ? 'Creating...' : 'Create'}
              </Button>
            </Box>
          </div>
          <Typography variant="subtitle1" style={{ color: 'red', marginTop: '-40px' }} textAlign="center">
            {state.errorMessage}
          </Typography>
        </Box>
      )}

      {width > 1050 && (
        <Box
          component="img"
          sx={{
            width: '50%',
            height: '97%',
            objectFit: 'cover',
            padding: '1rem',
            borderRadius: '30px',
          }}
          alt="Rectangle"
          src={SideImage}
        />
      )}
    </Box>
  );
};

export default LogIn;
